'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordInput = function (_Component) {
  _inherits(PasswordInput, _Component);

  function PasswordInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PasswordInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      shown: false
    }, _this.id = _this.props.id ? _this.props.id : (0, _idGen2.default)('password-input'), _this.input = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PasswordInput, [{
    key: 'onShowHideClick',
    value: function onShowHideClick(event) {
      event.preventDefault();
      this.setState({ shown: !this.state.shown });
      this.input.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          passwordError = _props.passwordError,
          children = _props.children,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          value = _props.value,
          placeholder = _props.placeholder,
          ariaDescribedby = _props.ariaDescribedby;
      var shown = this.state.shown;

      return _react2.default.createElement(
        'div',
        { className: 'luna-form__group' },
        _react2.default.createElement(
          'div',
          {
            className: 'luna-form__field ' + (passwordError ? 'is-invalid' : '')
          },
          _react2.default.createElement(
            'label',
            { className: 'luna-label u-screenReader', htmlFor: this.id },
            'Password'
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'luna-inset luna-inset--small ' + (children ? 'luna-inset--left' : '')
            },
            _react2.default.createElement('input', {
              type: shown ? 'text' : 'password',
              className: 'luna-input',
              id: this.id,
              ref: function ref(input) {
                _this2.input = input;
              },
              placeholder: placeholder,
              onFocus: onFocus,
              onChange: onChange,
              onBlur: onBlur,
              value: value,
              'aria-describedby': ariaDescribedby
            }),
            _react2.default.createElement(
              'button',
              {
                className: 'luna-inset__action',
                type: 'button',
                onClick: this.onShowHideClick
              },
              shown ? 'Hide' : 'Show'
            ),
            children
          )
        )
      );
    }
  }]);

  return PasswordInput;
}(_react.Component);

PasswordInput.propTypes = {
  id: _propTypes2.default.string,
  onFocus: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  value: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  children: _propTypes2.default.node,
  ariaDescribedby: _propTypes2.default.string,
  passwordError: _propTypes2.default.bool
};

exports.default = PasswordInput;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/PasswordInput/PasswordInput.js